import { render, staticRenderFns } from "./SSFooter.vue?vue&type=template&id=7c571d8d&scoped=true&"
var script = {}
import style0 from "./SSFooter.vue?vue&type=style&index=0&id=7c571d8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c571d8d",
  null
  
)

export default component.exports